import { render, staticRenderFns } from "./ShoppingList.vue?vue&type=template&id=3edda7c9&"
import script from "./ShoppingList.vue?vue&type=script&lang=js&"
export * from "./ShoppingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports